<!--
 * @Author: yang bo
 * @Date: 2019-12-03 14:42:03
 * @LastEditors: yang bo
 * @LastEditTime: 2019-12-03 16:48:05
 * @Description:
 -->

<template>
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item>风控平台</el-breadcrumb-item>
    <el-breadcrumb-item v-for="o in breadcrumbList" :key="o.id">{{o.name}}</el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["breadcrumbList"]
};
</script>



// WEBPACK FOOTER //
// src/components/include/Breadcrumb.vue